import React, { createContext, useContext, useState, useEffect } from 'react';
import { hasCapability as checkCap } from '../constants/roles';
import { dataService } from '../services/dataService';

const WorkspaceRoleCtx = createContext({ role: null, hasCapability: () => false });

export function WorkspaceRoleProvider({ workspaceId, userId, children }) {
  const [role, setRole] = useState(null);

  useEffect(() => {
    if (!workspaceId || !userId) { setRole(null); return; }
    const unsub = dataService.subscribeWorkspace(workspaceId, (ws) => {
      if (!ws) { setRole(null); return; }
      if (ws.userId === userId) { setRole('owner'); return; }
      const mr = ws.memberRoles || {};
      setRole(mr[userId] || null);
    });
    return () => unsub && unsub();
  }, [workspaceId, userId]);

  const cap = (capability) => {
    if (!role) return false;
    return checkCap(role, capability);
  };

  return (
    <WorkspaceRoleCtx.Provider value={{ role, hasCapability: cap }}>
      {children}
    </WorkspaceRoleCtx.Provider>
  );
}

export function useWorkspaceRole() {
  return useContext(WorkspaceRoleCtx);
}
